import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setKambiClientVisibility } from '@core/Areas/KambiClient/Store'
import { toggleKambiVisibility } from '@core/Areas/KambiClient/helpers'
import { setNewKambiSportsOfferingIntegrationSetting } from '@core/Areas/Settings/Store'
import { getKambiSportsOfferingIntegrationOverrideSetting } from '@core/Areas/Settings/Store/selectors'
import { SettingItemWithCheckbox } from '../Common/SettingItemWithCheckbox'

// INTERNAL ONLY: remove when shipping wider PROD audience
export const KambiSportsOfferingIntegrationOverrideSetting: React.FC = () => {
  const dispatch = useDispatch()
  const isEnabled = useSelector(getKambiSportsOfferingIntegrationOverrideSetting)

  return (
    <SettingItemWithCheckbox
      isEnabled={isEnabled}
      label='Enable new Kambi sports offering integration'
      description='Internal only. Locally overrides the feature on this device.'
      onToggle={() => {
        dispatch(setNewKambiSportsOfferingIntegrationSetting(!isEnabled))
        // fix for bug where kambi client shows when toggling sport setting
        dispatch(setKambiClientVisibility(false))
        toggleKambiVisibility(false)
      }}
    />
  )
}
